export default __webpack_public_path__ + "static/media/Create_Meal_Plan.66a7b831.svg";